import React, { useEffect, useState } from "react";
import { api, API_BASE } from "@/lib/api";
import { Modal, Btn, Input } from "@/components/erp/ui";
import { toast } from "sonner";
import { Sparkles, Send } from "lucide-react";

const waNum = (p) => String(p || "").replace(/\D/g, "").replace(/^0/, "62");
const template = (a) => `Halo ${a.customer_name || ""}, berikut hasil ${a.round_label} untuk ${a.product || a.wo_code}. Silakan buka link ini, cek file, lalu klik ACC atau Minta Revisi: [LINK]`;

async function streamDraft(aid, channel, hint, onText) {
  const res = await fetch(`${API_BASE}/design/approvals/${aid}/draft`, { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ channel, hint }) });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).detail || "AI gagal");
  const reader = res.body.getReader(); const dec = new TextDecoder(); let buf = ""; let out = "";
  for (;;) {
    const { done, value } = await reader.read(); if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n"); buf = parts.pop();
    for (const p of parts) {
      const d = p.replace(/^data: /, ""); if (d === "[DONE]") return out;
      const j = JSON.parse(d); if (j.error) throw new Error(j.error);
      out += j.t; onText(out);
    }
  }
  return out;
}

// Tulis pesan approval ke customer (manual atau dibantu AI) lalu kirim via WA / Email
export const MessageComposer = ({ item, channel, onClose, onSent }) => {
  const [text, setText] = useState("");
  const [hint, setHint] = useState("");
  const [busy, setBusy] = useState(false);
  const [aiBusy, setAiBusy] = useState(false);
  useEffect(() => { if (item) { setText(template(item)); setHint(""); } }, [item]);
  const ai = async () => {
    setAiBusy(true); setText("");
    try { await streamDraft(item.id, channel, hint, setText); } catch (e) { toast.error(e.message); setText(template(item)); }
    setAiBusy(false);
  };
  const send = async () => {
    if (!text.trim()) { toast.error("Pesan kosong"); return; }
    setBusy(true);
    const win = channel === "wa" ? window.open("about:blank", "_blank") : null;
    try {
      const body = channel === "email" ? { action: "email", message: text.replaceAll("[LINK]", "") } : { action: "wa" };
      const { data } = await api.post(`/design/approvals/${item.id}/mark`, body);
      const msg = text.includes("[LINK]") ? text.replaceAll("[LINK]", data.link) : `${text}\n${data.link}`;
      if (win) win.location.href = `https://wa.me/${waNum(item.whatsapp)}?text=${encodeURIComponent(msg)}`;
      toast.success(channel === "email" ? "Email terkirim ke customer" : "WhatsApp dibuka");
      onSent();
    } catch (e) { if (win) win.close(); toast.error(e.response?.data?.detail || "Gagal"); }
    setBusy(false);
  };
  return (
    <Modal open={!!item} onClose={onClose} title={item ? `Kirim via ${channel === "email" ? "Email" : "WhatsApp"} · ${item.wo_code}` : ""}
      footer={<><Btn variant="ghost" data-testid="composer-cancel" onClick={onClose}>Batal</Btn><Btn data-testid="composer-send" disabled={busy || aiBusy} onClick={send}><Send className="w-4 h-4" /> Kirim</Btn></>}>
      <div className="flex flex-col sm:flex-row gap-2 mb-2">
        <Input data-testid="composer-hint" placeholder="Arahan untuk AI (opsional), mis. lebih formal" value={hint} onChange={(e) => setHint(e.target.value)} />
        <Btn variant="ghost" className="whitespace-nowrap shrink-0" data-testid="composer-ai" disabled={aiBusy} onClick={ai}><Sparkles className="w-4 h-4" /> {aiBusy ? "Menulis..." : "Tulis dengan AI"}</Btn>
      </div>
      <textarea data-testid="composer-text" value={text} onChange={(e) => setText(e.target.value)} rows={8} className="w-full border border-slate-200 rounded-lg p-3 text-sm" />
      <p className="text-[11px] text-slate-400 mt-1">[LINK] otomatis diganti link file approval. Silakan cek & edit sebelum kirim.</p>
    </Modal>
  );
};
